import type { FaireProductEntity } from "../../entity_types/product";

export const p_qvasuqk42v: FaireProductEntity = {
  token: "p_qvasuqk42v",
  type: "product",
  name: "Raw Blue Kyanite by Kilo (minimum 5 kilos)",
  brandToken: "b_gy2hjqt9aj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/719ceada5242b7bcbd2bbeb606efea2e7508d5f84d24744e6780f11b994f9adc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b97c292c5ad75d4240734d9ae9d8c6c7f9e486f3f77edf1490da947835dd928.jpeg",
    "https://cdn.faire.com/fastly/6d4f290cb65b017cb61508dc279ddf028760224b042ecba5ce6f6b4a14d23f92.jpeg",
    "https://cdn.faire.com/fastly/94042f4c2594d3d3f7058b84910a6cfd9ad64baf5ea122073112799d8085b136.jpeg",
  ],
  priceDollars: 23.19,
  description:
    'Raw Blue Kyanite per Kilo. Minimum Purchase 5 Kilos\n\nSpecial offer: Enjoy a 20% discount off the wholesale price when purchasing a lot of 5 kilos or more of raw blue kyanite.\n\nA 5-kilo lot of blue kyanite includes between 4 to 8 pieces, each weighing up to 2 kilos. This variety ensures an interesting selection for any collector or natural stone enthusiast.\n\nFor both aesthetic and practical presentation, the bases of the pieces are cut, allowing them to stand upright. This feature not only enhances the natural beauty of blue kyanite but also makes it easier to display and handle.\n\nRepresentative product images ensure that the kyanite pieces selected for shipment maintain a quality similar to that shown in the reference images. The main image shows an example of 5 kilos of kyanite.\n\nThe price is per kilo, with a minimum purchase of 5 kilos.\n\nBlue kyanite is often called "the Sword of Archangel Michael" in metaphysics and spirituality.\n\nThis designation symbolizes its connection to Michael’s strength and protection, emphasizing its ability to cut negative energies and act as a protective shield.\n\nThis stone is considered a powerful ally for spiritual cleansing and strength, aligning it with the image of the archangel as a spiritual warrior.',
  tags: [],
  msrpDollars: 46.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:22.668Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
